import {
	getPackParametricCode,
	isManagedStructurePackEnabled
} from "~/utils/product/packChooseCount";

/**
 * Whether this deployment sells configurable packs —
 * `NORCE_MANAGED_STRUCTURE_PACK_PARAMETRIC`. `packCode` is the code itself,
 * for `getPackChooseCount`.
 */
export const usePacksEnabled = () => {
	const packCode = getPackParametricCode();

	return { packCode, packsEnabled: isManagedStructurePackEnabled(packCode) };
};
